import { produce } from 'immer';
import {
  WISHLISTCATALOGUE_LOADED,
  WISHLIST_LOADED,
  WISH_LOADED,
  WISHLIST_SHARED
} from './wishlist.actions';

export const initialState = {
  wishListCatalogue: [],
  wishList: undefined,
  wish: {},
};

export const wishListReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case WISHLISTCATALOGUE_LOADED:
        draft.wishListCatalogue = action.payload;
        return;
      case WISHLIST_LOADED:
        draft.wishList = action.payload;
        return;
      case WISH_LOADED:
        draft.wish = action.payload;
        return;
      case WISHLIST_SHARED:
        draft.wishList = action.payload;
    }
  });
